module.exports = __webpack_public_path__ + "img/2024-11-15a_1.b3a36415.jpg";